import { applicationApi } from '../../common/api';
import { Umkm } from './types';

export const umkmApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUmkm: builder.query<Umkm[], void>({
      query: () => `umkm`,
      providesTags: [{ type: 'Umkm', id: 'LIST' }],
    }),
    getUmkm: builder.query<Umkm, string>({
      query: (id) => `umkm/${id}`,
    }),
    createUmkm: builder.mutation<Umkm, any>({
      query: (body) => ({
        url: '/umkm',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Umkm', id: 'LIST' }],
    }),
    deleteUmkm: builder.mutation<any, number>({
      query: (id) => ({
        url: `umkm/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Umkm', id: 'LIST' }],
    }),
    updateUmkm: builder.mutation<Umkm, any>({
      query: (body) => ({
        url: '/umkm',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'Umkm', id: 'LIST' }],
    }),
  }),
});

export const { useGetAllUmkmQuery, useGetUmkmQuery, useCreateUmkmMutation, useDeleteUmkmMutation, useUpdateUmkmMutation } = umkmApi;
